import axios from '../../axios';
import {
   GET_PRINT_FORMATS,
   ADD_PRINT_FORMATS,
   UPDATE_PRINT_FORMATS,
   DELETE_PRINT_FORMATS,
   GET_ONE_PRINT,
} from '../types';
import { toast } from 'react-toastify';

export const getPrintFormat = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/printFormat/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_PRINT_FORMATS, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const addPrintFormat = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/printFormat/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_PRINT_FORMATS, payload: res.data.data });
         setTimeout(() => {
            toast.success('Print Format added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updatePrintFormat = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/printFormat/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PRINT_FORMATS, payload: res.data.data });

         setTimeout(() => {
            toast.success('Print Format updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const deletePrintFormat = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/printFormat/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PRINT_FORMATS, payload: { id } });
         toast.success('Print Format deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const getPrintFormatById = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/account/${id}`);
      const res = await axios.get(`/printFormat/${params}`);

      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_PRINT, payload: res.data.data, single: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log('err', err.response);
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};
